import { Badge } from "@artprov/design-system";
import { getStatusVariant } from "./invoiceStatus";

/**
 * Función para renderizar el estado de una factura con un Badge
 * @param {string} estado - El estado de la factura (pendiente, rechazada, aprobada, en progreso, enviada)
 * @returns {JSX.Element} Componente Badge con la variante correspondiente
 */
export const renderEstado = (estado) => {
  return (
    <div className="flex justify-start">
      <Badge variant={`status-${getStatusVariant(estado)}`}>{estado}</Badge>
    </div>
  );
};